import { render, staticRenderFns } from "./ParametreList.vue?vue&type=template&id=3403218d&scoped=true"
import script from "./ParametreList.vue?vue&type=script&lang=js"
export * from "./ParametreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403218d",
  null
  
)

export default component.exports